import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { ProductType } from '../types';
import { ChipStatus } from './ChipStatus';

export const useProductDetailsUtils = ({ variantsCount, type }: { variantsCount?: number; type?: ProductType }) => {
    const t = useTranslations('Discover.Pdp.information.selector');

    const productSelectionTitle = useMemo(() => {
        if (!type) {
            return '';
        }

        const monoSkuWithLinkedProducts =
            type === ProductType.MONO_SKU && variantsCount && variantsCount > 1
                ? {
                      [ProductType.MONO_SKU]: t('modal.label.selectMultiFormatTitle'),
                  }
                : undefined;

        const titleMap: Partial<Record<ProductType, string>> = {
            ...monoSkuWithLinkedProducts,
            [ProductType.MULTI_SKU_SIZE]: t('modal.label.selectMultiSkuSizeTitle'),
            [ProductType.MULTI_SKU_SHADE_UNI]: t('modal.label.selectMultiSkuShadeTitle'),
            [ProductType.MULTI_SKU_SHADE_DIFF]: t('modal.label.selectMultiSkuShadeTitle'),
        };

        return titleMap[type] ?? '';

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    const getStockInformation = (isAvailable: boolean): { label: string; status: ChipStatus } => {
        return {
            label: t(`modal.label.${isAvailable ? 'available' : 'unavailable'}`),
            status: isAvailable ? ChipStatus.Success : ChipStatus.Error,
        };
    };

    return { productSelectionTitle, getStockInformation };
};
